import React, { useEffect, useState } from 'react';
import LoadingSpinner from 'components/styleguide/loading_spinner/LoadingSpinner';

const styles = require('./AiLoadingModal.module.scss');

interface AiLoadingModalProps {
  imageUrl: string;
  isOpen?: boolean;
  triggerId?: string;
  context?: 'talent' | 'company';
}

export default function AiLoadingModal({ imageUrl, isOpen: controlledOpen, triggerId, context = 'company' }: AiLoadingModalProps) {
  const [internalOpen, setInternalOpen] = useState(false);
  const isOpen = controlledOpen ?? internalOpen;

  useEffect(() => {
    const img = new Image();
    img.src = imageUrl;
  }, [imageUrl]);

  useEffect(() => {
    if (!triggerId) return;

    const trigger = document.getElementById(triggerId);
    if (!trigger) return;

    const handleOpen = () => setInternalOpen(true);
    trigger.addEventListener('click', handleOpen);
    return () => trigger.removeEventListener('click', handleOpen);
  }, [triggerId]);

  if (!isOpen) return null;

  return (
    <div className={styles.backdrop}>
      <div className={styles.modal}>
        <img src={imageUrl} alt="" />
        <div className={styles.content}>
          <LoadingSpinner size="small" context={context} />
          <p className={styles.text}>Preparing your profile...</p>
        </div>
      </div>
    </div>
  );
}
